/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns = nspace("ccc.indicatorSelection");

  ns.IndicatorSelectionTreeView = Backbone.View.extend({
    initialize: function() {
      _.bindAll(this, "render");
      var self = this;

      this.model.on("change", this.render);

      // Flash the indicator tree whenever the tab changes so the user knows
      // the it has been updated.
      // NOTE: Disabled for now... seemed too "heavy handed"
      //this.model.on("change:currentTab", function() {
      //	$(".indicator-lists-container").stop(true, true).effect("highlight", 700);
      //});

      // Listen for clicks on the category nodes and toggle their visibilty
      $(".indicator-lists-container").on(
        "click",
        "li[data-top-category] .indicator-list-link",
        function(e) {
          var $catNode = $(this).closest("li[data-top-category]");
          var id = $catNode.data("category-id");

          var selectedIds = self.model.get("selectedCategories");
          var newIds;
          if (_.has(selectedIds, id)) {
            // update the model
            newIds = _.omit(selectedIds, "" + id); // _.omit seems to be broken for int keys, so stringify the id
            self.model.set("selectedCategories", newIds);
          }
          else {
            // update the model
            newIds = {};
            newIds[id] = true;
            _.extend(newIds, selectedIds);
            self.model.set("selectedCategories", newIds);
          }
        }
      );

      // Listen for a click on the "expand/collapse" button and update the model
      $(".indicator-tree-toggle").on("click", function() {
        var $topLevelCategories = $("li[data-top-category]"),
          ids = self.model.get("selectedCategories"),
          newIds = {};

        self.suppressEDIndicatorExpansion = true;

        // if the number of selectedCategories in the model is equal to the
        // number of li's in the view, collapse; otherwise, expand
        if ($topLevelCategories.length === _.size(ids)) {
          // collapse
          self.model.set("selectedCategories", {});
        }
        else {
          // Tracks when a user clicks the "Expand All" button on the "Explore Data" page
          dataLayer.push({
            event: "ED Expand All",
            eventCategory: "Interactive Clicks",
            eventAction: "ED Expand All",
            eventLabel: window.location.pathname
          });

          $topLevelCategories.each(function() {
            newIds[$(this).data("category-id")] = true;
          });
          self.model.set("selectedCategories", newIds);
        }

        self.suppressEDIndicatorExpansion = false;
      });
    },

    render: function() {
      // The tree html is rendered on the server side, so just
      // hide or show the indicator & category nodes that correspond with
      // the currently selected location type
      var self = this;
      var elementsToHide = [];
      var elementsToShow = [];
      var $topLevelCategories = $("li[data-top-category]");

      function isHidden($element) {
        // The :visible/:hidden pseduoselectors are affected by parent visibility, but
        // for the purposes of deciding what to show, we need to know if the elements
        // would be hidden even if the parent element is not.
        // Test this by checking for CSS styles.
        return (
          $element
            .stop(true, true) // Finish any pending animations immediately, or we can't be sure
            .css("display") === "none"
        ); // In this case, we need only look at "display"
      }

      function hideOrShow($elements, notHiddenCallback) {
        $elements.each(function() {
          var rawIds, areIdsMultiple, ids;

          // Parse out the list of location type Ids and see if
          // the current loc type ID is contained within
          var locTypeId = self.model.get("currentTabId");
          rawIds = $(this).data("loctype-ids");
          // We may get into a situation where we only have one location type defined for a category/indicator.
          // In this case, if there's only one location, .data will return an int, which doesn't have a split
          // function. So checking for the existing of that function will tells us to either split the location
          // type id or wrap it in an array.
          areIdsMultiple = !!rawIds.split;
          ids = areIdsMultiple ? rawIds.split(",") : [rawIds];

          var index = $.inArray("" + locTypeId, ids);

          if (index > -1 && isHidden($(this))) {
            elementsToShow.push(this);
          }
          else if (index === -1 && !isHidden($(this))) {
            elementsToHide.push(this);

            // No need to continue since all children are now hidden
            return;
          }

          // The element wasn't hidden, so invoke the callback
          if (notHiddenCallback) {
            notHiddenCallback(this);
          }
        });
      }

      // If the current tab id is "any", show everything
      if (this.model.get("currentTabId") < 1) {
        // Anything with a "data-loctype-ids" attribute is potentially hidden
        $.merge(
          elementsToShow,
          $("[data-loctype-ids]").filter(function() {
            return isHidden($(this));
          })
        );
      }
      else {
        // Examine the top level categories first, then the subtopics, and finally
        // the individual indicator nodes.
        hideOrShow($("[data-top-category]"), function(parent) {
          // Sub Categories
          hideOrShow($("[data-category]", parent), function(nextParent) {
            // Indicators within sub categories
            hideOrShow($("[data-indicator]", nextParent));
          });

          // Indicator nodes directly under the top level
          hideOrShow($("[data-indicator]", parent));
        });
      }

      $(elementsToHide).slideUp(700);
      $(elementsToShow).slideDown(700);

      // Open / close the top level tree nodes as necessary
      var selectedIds = self.model.get("selectedCategories");
      $topLevelCategories.each(function() {
        var catId = $(this).data("category-id");
        var $container = $(".indicator-list-toggle-container", this);
        var catIsSelected = _.has(selectedIds, catId);
        if (catIsSelected && isHidden($container)) {
          $container.slideDown();
          $(".indicator-list-link", this).addClass("active");

          // Tracks clicks on indicator expansion (Demographics, Economic Conditions, etc) on the "Explore Data" page
          var locationType = $(".location-type-link.active")
            .text()
            .trim();
          var categoryName = $(".indicator-list-link", this)
            .text()
            .trim();
          if (!self.suppressEDIndicatorExpansion) {
            dataLayer.push({
              event: "ED Indicator Expansion",
              eventCategory: "Interactive Clicks",
              eventAction:
                "Indicator Expansion|" + locationType + "|" + categoryName,
              eventLabel: window.location.pathname
            });
          }
        }
        else if (!catIsSelected && !isHidden($container)) {
          $container.slideUp();
          $(".indicator-list-link", this).removeClass("active");
        }
      });

      $(".indicator-tree-toggle").text(
        _.size(selectedIds) === $topLevelCategories.length
          ? "Collapse All"
          : "Expand All"
      );
    }
  });
})(jQuery, _);
